/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockAdjustDetailResVo } from './StockAdjustDetailResVo';
import {
    StockAdjustDetailResVoFromJSON,
    StockAdjustDetailResVoFromJSONTyped,
    StockAdjustDetailResVoToJSON,
    StockAdjustDetailResVoToJSONTyped,
} from './StockAdjustDetailResVo';

/**
 * 
 * @export
 * @interface ResponseListStockAdjustDetailResVo
 */
export interface ResponseListStockAdjustDetailResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStockAdjustDetailResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStockAdjustDetailResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<StockAdjustDetailResVo>}
     * @memberof ResponseListStockAdjustDetailResVo
     */
    data?: Array<StockAdjustDetailResVo>;
}

/**
 * Check if a given object implements the ResponseListStockAdjustDetailResVo interface.
 */
export function instanceOfResponseListStockAdjustDetailResVo(value: object): value is ResponseListStockAdjustDetailResVo {
    return true;
}

export function ResponseListStockAdjustDetailResVoFromJSON(json: any): ResponseListStockAdjustDetailResVo {
    return ResponseListStockAdjustDetailResVoFromJSONTyped(json, false);
}

export function ResponseListStockAdjustDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStockAdjustDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StockAdjustDetailResVoFromJSON)),
    };
}

export function ResponseListStockAdjustDetailResVoToJSON(json: any): ResponseListStockAdjustDetailResVo {
    return ResponseListStockAdjustDetailResVoToJSONTyped(json, false);
}

export function ResponseListStockAdjustDetailResVoToJSONTyped(value?: ResponseListStockAdjustDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StockAdjustDetailResVoToJSON)),
    };
}

